import React, { useMemo } from 'react';

import dayjs from 'dayjs';
import locale from 'dayjs/locale/pt-br';
import { Descriptions, DescriptionsProps, Flex } from 'antd';
import { SeverityColor } from 'src/pages/occurrences/OccurrenceDetails/styles';
import { OcurrenceData } from 'src/interfaces/entities/occurence-data';
import { Occurrence } from 'src/interfaces/entities/occurrence';
import ObserverHistory from 'src/components/ObserverHistory';

dayjs.locale(locale);

export default function OccurrenceDescription(
	{
		data,
	}: { data?: (Occurrence & { ocurrence_data: OcurrenceData }) }
) {

	const items = useMemo<DescriptionsProps['items']>(() => [
		{
			key: '1',
			label: 'Observador disparado',
			children: <Flex gap={8}>
				{data?.observer.name}
				{data && (
					<ObserverHistory
						observer={{
							...data.observer,
							observer_id: data.observer_id,
						}}
					/>
				)}
				
			</Flex>,
		},
		{
			key: '2',
			label: 'Data/Hora',
			children: (() => {
				if (data?.creation_date) {
					return dayjs(data?.creation_date).format('DD MMM YYYY, HH:mm');
				}
				return <></>;
			})(),
		},
		{
			key: '3',
			label: 'Severidade',
			children: <>
				<Flex gap={8} align='center'>
					<SeverityColor
						style={{
							backgroundColor: data?.observer?.severity.color,
						}}
					/>
					{data?.observer?.severity.name}
				</Flex>
			</>,
		},
		{
			key: '4',
			label: 'Mensagem disparada',
			children: data?.preview_message,
		},
	], [ data, ]);

	return <Descriptions
		title='Dados da ocorrências'
		items={items}
		bordered
		layout='vertical'
		size='small'
	/>;
}
